import { AvatarSize } from '@app/src/components/Ui/Avatar'
import TruncatingText from '@app/src/components/Ui/TruncatingText'
import PersonAvatar from '@app/src/pages/ResourceCollection/Collections/CellComponents/PersonAvatar'
import { ButtonBase, Stack } from '@mui/material'
import React from 'react'

export type UserInlineProps = {
  name: string
  size?: AvatarSize
  onClick?: () => void
  isDisabled?: boolean
  hoverUnderline?: boolean
  fullWidth?: boolean
  dataTestId?: string
}

const UserInline: React.FC<UserInlineProps> = ({
  name,
  size = AvatarSize.Small,
  onClick,
  isDisabled,
  hoverUnderline = true,
  fullWidth = false,
  dataTestId = 'user-inline-name',
}) => {
  const ComponentTag: React.ElementType = onClick ? ButtonBase : 'span'

  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1}
      component={ComponentTag}
      onClick={onClick}
      width={fullWidth ? '100%' : undefined}
      sx={{ minWidth: 0 }}
    >
      <PersonAvatar name={name} size={size} disabled={isDisabled} />
      <TruncatingText
        text={name}
        variant="body1"
        align="left"
        data-testid={dataTestId}
        sx={{
          '&:hover': { textDecoration: onClick && hoverUnderline ? 'underline' : 'none' },
          ...(fullWidth && { flexGrow: 1, flexBasis: 0 }),
        }}
      />
    </Stack>
  )
}

export default UserInline
